import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ValidationErrors} from "@angular/forms";
import {required} from "@atl/shared/validators";
import {IEventStatus, LtaSelectOptionModel} from "@atl/lacerta-ui-common";
import {TranslatePipe} from "@ngx-translate/core";
import {UntilDestroy} from "@ngneat/until-destroy";
import {EventClassesService} from "@atl/admin/event-classes/services";

export interface IEventStatusForm {
    value: number | boolean;
    eventClass: number;
    eventText: string;
    isValid: boolean;
}

@UntilDestroy()
@Component({
    selector: 'lta-event-status',
    templateUrl: './event-status.component.html',
    styleUrl: './event-status.component.scss',
})
export class EventStatusComponent implements OnInit {
    @Output() onChange: EventEmitter<IEventStatusForm> = new EventEmitter<IEventStatusForm>();
    @Output() onDelete: EventEmitter<void> = new EventEmitter<void>();
    statusForm: FormGroup = this.formBuilder.group({
        value: new FormControl(null, [required]),
        eventClass: new FormControl(null, [required]),
        eventText: new FormControl('', [required])
    })
    boolValueOptions: LtaSelectOptionModel<boolean>[] = [
        {name: 'True', value: true},
        {name: 'False', value: false},
    ];
    eventClassesOptions: LtaSelectOptionModel<number>[] = [];
    @Input() readonly = false;
    @Input() index: number;
    private currentStatus: IEventStatus;
    private currentErrors: ValidationErrors;

    constructor(
        private formBuilder: FormBuilder,
        private eventClassesService: EventClassesService,
        private translate: TranslatePipe,
    ) {
    }

    // 2 - bool; 3 - int
    private _modelType: 2 | 3;
    private _prevModelType: 2 | 3;

    get modelType() {
        return this._modelType;
    }

    @Input()
    set modelType(modelTypeId: 2 | 3) {
        this._modelType = modelTypeId ?? 3;
        this.statusForm.patchValue({
            value: this._modelType == 2
                ? this.currentStatus.value_bool
                : this.currentStatus.value_int64,
        })

        if (this.statusForm.get('value').value !== undefined) {
            this.statusForm.get('value').markAsTouched();
        }

        if (!!this._prevModelType && this._prevModelType !== modelTypeId) {
            this.statusForm.get('value').reset();
            this.statusForm.get('value').markAsPristine();
        }
        this._prevModelType = modelTypeId;
    }

    @Input() set data(value: IEventStatus) {
        this.currentStatus = value;
        this.statusForm.reset({
            eventClass: {value: value.event_class_id, disabled: this.readonly},
            eventText: {value: value.message, disabled: this.readonly}
        })
    }

    @Input() set isValueUnique(isUnique: boolean) {
        const setErrors = () => {
            this.statusForm.controls.value.markAsTouched();
            const errors = {
                incorrect: true,
                message: this.translate.transform('lta-errors.uniqueValue')
            };
            this.statusForm.controls.value.setErrors(errors);
            this.currentErrors = errors;
        }

        const valueField = this.statusForm.get('value');

        if (valueField.value === '' || this.readonly) return;

        valueField.setErrors(null);
        if (!isUnique && valueField.touched) {
            setErrors();
        } else {
            this.currentErrors = null;
        }
    }

    ngOnInit(): void {
        this.eventClassesService.eventClassesMap.forEach((val, key) => {
            const truncateText = (text, size) => text.length > size ? text.slice(0, size) + "..." : text;
            this.eventClassesOptions.push({name: truncateText(val.name, 45), value: key})
        });

        if (this.readonly) {
            this.statusForm.disable();
        }

        this.statusForm.valueChanges.subscribe(value => {
            // if (this.currentErrors) {
            //     this.statusForm.controls.value.setErrors(this.currentErrors);
            // }
            this.onChange.next({
                ...value,
                isValid: this.statusForm.controls.eventClass.valid
                    && this.statusForm.controls.eventText.valid
                    && this.statusForm.get('value').value !== '',
            })
        })
    }
}
